export enum Currency {
    USD = "USD",
    EURO = "EUR"
}